import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { StringRequest } from "../../../siteadmin/school-type-setup/shared/StringRequest";
import { DataService_PBISSetup } from "../shared/data.service";
import { MeritInsertRequest } from "../shared/MeritInsertRequest";
import { PBISSchoolOrDistrictComponent } from "../shared/pbisschool-or-district/pbisschool-or-district.component";

@Component({
	selector: "app-school-add-merit",
	templateUrl: "./school-add-merit.component.html",
	styleUrls: ["./school-add-merit.component.css"],
})
export class SchoolAddMeritComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private PBISSetupService: DataService_PBISSetup,
		private dialogService: DialogService
	) {}

	ngOnInit(): void {
		//Get data from parent
		this.user = this.dialogConfig.data.user;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SchoolName = this.dialogConfig.data.SchoolName;

		//INSERT LOAD COMBO BOX DATA
	}

	///////////////////////////////////////
	// Data
	///////////////////////////////////////

	errorMessage: any = "";

	//Data from parent
	user: any;
	SchoolID: any;
	SchoolName: any;

	//INSERT FORM DATA
	MeritCD: any = "";
	MeritDesc: any = "";
	IsDemerit: any = "0";
	DefaultValue: any = 0;
	MinValue: any = 0;
	MaxValue: any = 0;
	EDCRAssignable: any = false;
	QuickMerit: any = false;

	///////////////////////////////////////

	///////////////////////////////////////
	// Load Data
	///////////////////////////////////////

	//INSERT LOAD DATA METHODS

	///////////////////////////////////////

	///////////////////////////////////////
	// Buttons
	///////////////////////////////////////

	//INSERT CUSTOM BUTTON METHODS
	onAddMerit() {
		this.errorMessage = "";

		//Error handling
		if (this.MeritCD == "") {
			this.errorMessage = "Please enter a Code or Abbreviation";
			return;
		} else if (this.MeritDesc == "") {
			this.errorMessage = "Please enter a Name or Description";
			return;
		} else if (this.DefaultValue == undefined) {
			this.errorMessage = "Please enter a default merit value";
			return;
		} else if (this.MinValue == undefined) {
			this.errorMessage = "Please enter a minimum merit value";
			return;
		} else if (this.MaxValue == undefined) {
			this.errorMessage = "Please enter a maximum merit value";
			return;
		}

		//Merit Values
		else if (this.DefaultValue < this.MinValue) {
			this.errorMessage = "Default value must be >= Minimum Value";
			return;
		} else if (this.DefaultValue > this.MaxValue) {
			this.errorMessage = "Default value must be <= Maximum Value";
			return;
		} else {
			//Check CD
			this.CheckCD();
			//Check Desc
		}
	}

	CheckCD() {
		let parms: StringRequest = {
			str: this.MeritCD,
		};

		var result = this.PBISSetupService.MeritCodeInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Merit Code already in use";
					return;
				} else {
					this.CheckDesc();
				}
			},
			(error) => {}
		);
	}

	CheckDesc() {
		let parms: StringRequest = {
			str: this.MeritDesc,
		};

		var result = this.PBISSetupService.MeritDescInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Merit Description already in use";
					return;
				} else {
					//Add for school or district?
					if (this.user.UserLevelID == 1) {
						var ref = this.dialogService.open(PBISSchoolOrDistrictComponent, {
							header: "School or District",
							width: "fit-content",
							data: {
								SchoolName: this.SchoolName,
							},
						});
						ref.onClose.subscribe((response) => {
							if (response == 1) {
								this.FinishAdd(this.SchoolID);
							} else {
								this.FinishAdd(0);
							}
						});
					} else {
						this.FinishAdd(this.SchoolID);
					}
				}
			},
			(error) => {}
		);
	}

	FinishAdd(SID) {
		var DefinedBy = this.user.UserLevelID == 1 ? 4 : 3;

		let parms: MeritInsertRequest = {
			MeritCD: this.MeritCD,
			MeritDesc: this.MeritDesc,
			MeritValue: this.DefaultValue,
			MeritValueMin: this.MinValue,
			MeritValueMax: this.MaxValue,
			IsDemerit: this.IsDemerit == "1" ? 1 : 0,
			IsEDCRAssignable: this.EDCRAssignable == true ? 1 : 0,
			QuickMerit: this.QuickMerit == true ? 1 : 0,
			Active: 1,
			DefinedByID: DefinedBy,
			SchoolID: SID,
		};

		var result = this.PBISSetupService.MeritInsert(parms);

		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Merit was added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the Merit",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////
}
